;"use strict";
/**
 *  @author       F. Heitmann
 *  @description  A collection of modules often used in our shop projects.
 *                The library is intended to speed up the development by reducing the amount of project-specific code.
 *                This library is quite new, so some modules are not working together properly yet. (ie. collapse & sticky)
 **/
var Fuchs = {
	version: "V0.1α", /* α β γ δ ε */
	modules: {}, /* module storage */
	init: function(){
		var keys = Object.keys( this.modules );
		for( var i=0; i<keys.length; i++ ){
			try{
				this.modules[keys[i]]();
			} catch(e) {
				console.log( "There was an error in the module '"+keys[i]+"'." );
				console.log( e );
			}
		}
	},
	/**
	 *   @description This function calls the callback [wait]-miliseconds after it was last called.
	 *
	 *
	 **/
	debounce: function(callback, wait, immediate){
		immediate = immediate || false;
		var context = null;
		var args = null;
		var timeout_id = null;
		var exec_callback = function(){
			timeout_id = null;
			if( !immediate ){
				callback.apply(context, args);
			}
		};
		return function(){
			context = this;
			args = arguments;
			if( immediate && !timeout_id ){
				callback.apply(context, args);
			}
			clearTimeout(timeout_id);
			timeout_id = setTimeout(
				exec_callback,
				wait
			);
		};
	},
	/**
	 *   @desciption This function allows the callback to be called only after [wait]-miliseconds.
	 *
	 *   @TODO Expand this function by blocking function calls during an unfinished callback.
	 *         => Queue
	 **/
	throttle: function(callback, wait, trailing_call){
		trailing_call = trailing_call || false;
		var context = null;
		var args = null;
		var last_call_at = 0;
		var current_call_at = 0;
		if( !!trailing_call ){
			var debounce_func = Fuchs.debounce(
				function(){
					callback.apply(context, args);
				},
				wait, false
			);
		}
		return function(){
			context = this;
			args = arguments;
			if( typeof(debounce_func) != "undefined" ){ debounce_func(); }
			current_call_at = Date.now();
			if( current_call_at > (last_call_at + wait) ){
				callback.apply(context, args);
				last_call_at = current_call_at;
			}
		}
	},
	/**
	 *   @description This function creates big elements
	 *
	 **/
	create_element: function(str){
		var el = document.createElement("div");
		el.innerHTML = str;
		return el.children[0];
	},
	/**
	 *   @description Inserts an element as a direct sibling to the given element
	 *
	 **/
	insert_after: function (newNode, referenceNode){
		referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
	},
	insert_as_first_child: function (newNode, referenceNode){
		referenceNode.insertBefore(newNode, referenceNode.firstChild);
	},
};
window.addEventListener( "DOMContentLoaded", Fuchs.init.bind(Fuchs) );



;"use strict";
/**
 *  @module      |
 *  @author      |
 *  @description |
 */
Fuchs.modules.CollapsingMenu = function(){
	var coll_menus_list = document.querySelectorAll("ul[data-ezco-collapse-menu]");
	var i;
	for( i=0; i<coll_menus_list.length; i++ ){
		(function(){
			var el = coll_menus_list[i];

			var get_children_array = function(el){
				var children = [];
				var i = 0;
				for( i; i < el.children.length; i++ ){
					children.push( el.children[i] );
				}
				return children;
			};
			var el_children = get_children_array( el );

			/* create new elements */
			var collapsed_menu = Fuchs.create_element("<li class='collapsed_menu'></li>");
				var collapsed_menu_expand = Fuchs.create_element("<div class='collapsed_menu_expand'>MENU</div>");
				var collapsed_menu_content = Fuchs.create_element("<ul class='collapsed_menu_content' style='display: none;'></ul>");

			/* include elements into the DOM */
			collapsed_menu.appendChild( collapsed_menu_expand );
			collapsed_menu.appendChild( collapsed_menu_content );
			/* Fuchs.insert_as_first_child( collapsed_menu, el ); */

			/** This function is debounced, as it is heavy on DOM Manipulation!!! **/
			var main = Fuchs.debounce(
				function(){
					/* remove all elements, wherever they are */
					for( var i = 0; i < el_children.length; i++ ){
						var cur_el_child = el_children[i];
						cur_el_child.parentNode.removeChild( cur_el_child );
					}

					/* next insert the menu element */
					el.appendChild( collapsed_menu );

					/* measure inner height of the navi */
					var navi_height = el.clientHeight;

					/* go through all el_children and try to append them */
					var menu_filled = false;
					for( var i = 0; i < el_children.length; i++ ){
						var cur_child = el_children[i];

						/* after an item didnt fit, jump over the check +/
						/* and append directly to collapse_menu */
						if( !menu_filled ){
							el.appendChild( cur_child );

							/* if height changed, the element was put into the second line */
							if( navi_height !== el.clientHeight ){
								/* height changed - move child to collapsed menu */
								collapsed_menu_content.appendChild( cur_child );
								menu_filled = true;
							}
						} else {
							collapsed_menu_content.appendChild( cur_child );
						}
					}

					/* if nothing was moved into the collapsed_menu, remove it */
					if( collapsed_menu_content.children.length <= 0 ){
						el.removeChild( collapsed_menu );
					}
				},
				400,
				false
			);
			window.addEventListener( "resize", main );
			main();



			/* event listener for displaying the collapsed menu */
			var collapse_menu_showing = false;
			collapsed_menu_expand.addEventListener(
				"click",
				function(e){
					if( collapse_menu_showing ){
						collapsed_menu_content.style.display = "none";
						collapse_menu_showing = false;
					} else {
						collapsed_menu_content.style.display = "block";
						collapse_menu_showing = true;
					}
				}
			);

			// Generate a hidden element after all the menu items.
			// The element should have 3-bar icon.
			// It should contain all elements that are not fitting on the first row.
		}())
	}
};



;"use strict";
/**
 *  @module:      CookieDirectiveDialog
 *  @author       F. Heitmann
 *  @description
 **/
Fuchs.modules.CookieDirectiveDialog = function(){
	/* ask user to set an "accept cookies"-cookie, if not already set */
	var cd_box = document.querySelector("[data-ezco-cookie-directive]");
	if( !!cd_box ){
		function update_directive_attribute(status){
			if( status === "yes" ){
				/* cookies accepted */
				cd_box.setAttribute("data-ezco-cookie-directive", "accepted");
			} else if( status === "no" ){
				/* cookies rejected */
				cd_box.setAttribute("data-ezco-cookie-directive", "rejected");
			} else {
				/* not asked */
				cd_box.setAttribute("data-ezco-cookie-directive", "showing");
			}
		}
		function read_status_cookie(){
			var cookies = document.cookie.split(";");
			for(i=0;i<cookies.length;i++){
				var cur_cookie = cookies[i].trim().split("=");
				if( cur_cookie[0] == "accept-cookies" ){
					/* return cookie value */
					return cur_cookie[1];
				}
			}
			return "";
		}
		function accept_cookies(){
			document.cookie = "accept-cookies=yes;path=/";
			update_directive_attribute("yes");
		}
		function reject_cookies(){
			document.cookie = "accept-cookies=no;path=/";
			update_directive_attribute("no");
		}
		var accept_btn = cd_box.querySelector("[data-ezco-cookie-directive-accept]");
		var reject_btn = cd_box.querySelector("[data-ezco-cookie-directive-reject]");
		/* set button events */
		if( accept_btn !== null && typeof(accept_btn) !== "undefined" ){
			accept_btn.addEventListener(
				"click",
				accept_cookies
			);
			if( reject_btn !== null && typeof(reject_btn) !== "undefined" ){
				reject_btn.addEventListener(
					"click",
					reject_cookies
				);
			}
		}
		/* set directive status */
		update_directive_attribute( read_status_cookie() );
	}
};


;"use strict";
/**
 *  @module:      PasswordDisplay
 *  @author       F. Heitmann
 *  @description  Shows password fields in plain text, when pushing the show button.
 *                The custom attribute data-ezco-show-plain-password needs the id of the password field! (ONLY FIRST ONE!)
 **/
Fuchs.modules.PasswordDisplay = function(){
	var password_display_list = document.querySelectorAll("[data-ezco-show-plain-password]");
	var i;
	for( i=0; i<password_display_list.length; i++ ){
		(function(){
			var cur_password_display = password_display_list[i];
			var password_show_btn = Fuchs.create_element("<button type='button' class='password_show_btn'>"+cur_password_display.getAttribute("data-ezco-show-plain-password")+"</button>")
			Fuchs.insert_after( password_show_btn, cur_password_display);

			password_show_btn.addEventListener(
				"mousedown",
				function(e){
					cur_password_display.type = "text";
				}
			);
			password_show_btn.addEventListener(
				"mouseup",
				function(e){
					cur_password_display.type = "password";
				}
			);
			password_show_btn.addEventListener(
				"mouseleave",
				function(e){
					cur_password_display.type = "password";
				}
			);
		}())
	}
};



;"use strict";
/**
 *  @module       FormValidator
 *  @author       F. Heitmann
 *  @description  Validates a form and disables submission, until values are valid.
 *  @alert        This function DOES NOT replace a proper server-sided validation!!!
 **/
Fuchs.modules.FormValidator = function(){
	var validation_form_list = document.querySelectorAll("form[data-ezco-form-validator]");
	/* define validation unctions */
	var validate_not_empty = function( value ){ return (value != ""); };
	var validate_email = function( value ){
		/* original regex */
		/* var email_regex = new RegExp("[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\\.[a-zA-Z]+"); */
		/* self written after RFC 5322 official standard */
		/* var email_regex = new RegExp("/^(([-a-z0-9~!$%^&*_=+{}\']+[-a-z0-9~!$%^&*_=+{}\'\.]*)@([a-z0-9_][a-z0-9_\-\.]*)\.(museum|travel|[a-z][a-z0-9]{1,3}))$/i"); */
		/* shortened rfc variant */
		var email_regex = new RegExp(/^(([-a-z0-9~!$%^&*_=+{}\'\.]+)@([a-z0-9_\-\.]+)\.([a-z0-9]{2,6}))$/i);
		var regex_matches = value.match( email_regex );
		return ( regex_matches !== null ) && ( regex_matches[1] === value );
	};
	var validate_regex = function( value, regex_string ){
		var regex = new RegExp( regex_string );
		if( typeof(regex) !== "undefined" && regex !== null ){
			return regex.test( value );
		}
		return false;
	};
	/* loop through all forms to be validated */
	for( var i=0; i<validation_form_list.length; i++ ){
		(function(){
			var cur_validation_form = validation_form_list[i];
			var validation_inputs = cur_validation_form.querySelectorAll("[data-ezco-fv-input]");
			var validation_button = cur_validation_form.querySelector("[data-ezco-fv-submit]");
			/* TODO: JSON encoded form validation options (i.e. set throttle timer) */
			/* var options_json = cur_validation_form.getAttribute("data-ezco-form-validation"); */
			/* event bindings */
			cur_validation_form.addEventListener( "submit", function(e){
				if( !validate_form() ){
					/* when invalid, prevent submission */
					e.preventDefault();
				}
			} );
			/* bind input listener to each input field */
			for( var j=0; j<validation_inputs.length; j++ ){
				validation_inputs[j].addEventListener( "input", function(e){ validate_form(); } );
			}
			/* core validation management function */
			var validate_form = function(){
				/* go through all the input fields to be validated */
				var form_valid = true;
				var empty_count = 0;
				for( var j=0; j<validation_inputs.length; j++ ){
					(function(){
						var cur_element = validation_inputs[j];
						/* count empty values */
						if( !cur_element.value ){
							empty_count += 1;
						}
						var cur_valid = true;
						/* do validation check on validation type */
						var cur_validation_type = cur_element.getAttribute("data-ezco-fv-input");
						switch( cur_validation_type ){
							case "":
								cur_valid = validate_not_empty( cur_element.value );
							break;
							case "email":
								cur_valid = validate_email( cur_element.value );
							break;
							/* everything else is considered to be a regex */
							default:
								cur_valid = validate_regex( cur_element.value, cur_validation_type );
							break;
						}
						if( cur_valid ){
							cur_element.setAttribute("data-ezco-fv-valid", "valid");
						} else {
							cur_element.setAttribute("data-ezco-fv-valid", "invalid");
							form_valid = false;
						}
					}())
				}
				/* when all values are empty, delete the attributes again */
				if( empty_count == validation_inputs.length ){
					for( var j=0; j<validation_inputs.length; j++ ){
						validation_inputs[j].removeAttribute("data-ezco-fv-valid");
					}
				}
				/* update submit button status */
				if( !form_valid ){
					validation_button.disabled = true;
				} else {
					validation_button.disabled = false;
				}
				/* return validation status in order to react to it */
				return form_valid;
			};
			/* finally trigger the validation once */
			validate_form();
		}())
	}
};



;"use strict";
/**
 *  @module:      Packing Unit
 *  @author       F. Heitmann
 *  @description  This function checks a packaging unit and proposes a fitting amount.
 *                Will be triggered on form submit.
 *  @example
 *   <input     data-ezco-packing-unit="[vpe_artikel]"     />
 **/
/** TODO: Rework on example **/
Fuchs.modules.PackingUnit = function(){
	var packing_unit_list = document.querySelectorAll("[data-ezco-packing-unit]");
	var i;
	for( i=0; i<packing_unit_list.length; i++ ){
		(function(){
			var el = packing_unit_list[i];
			// el.form selects the form around that element!
			el.form.onsubmit = function(e){
				var value = parseInt(el.value);
				var VE = parseInt(el.getAttribute("data-ezco-packing-unit"));
				if( !VE || value%VE == 0 ){
					// ok
					// let the event pass
				} else {
					// not ok
					var proposal = Math.ceil(value/VE)*VE;
					if( confirm(unescape("Sie haben eine Anzahl angegeben, die nicht einem Vielfachen der Verpackungseinheit ("+VE+") entspricht.\r\nM%F6chten Sie stattdessen "+proposal+" St%FCck bestellen?")) ){
						// set value to proposal
						el.value = proposal;
					} else {
						// abort
						e.preventDefault();
					}
				}
			};
		}())
	}
};












;"use strict";
/**
 *  @module:      Sticky
 *  @author       F. Heitmann
 *  @description  This function looks for sticky elements in the website.
 *                Uses the attribute "data-ezco-sticky".
 **/
Fuchs.modules.Sticky = function(){
	var sticky_list = document.querySelectorAll("[data-ezco-sticky]");
	var i;
	for( i=0; i<sticky_list.length; i++ ){
		(function(){
			var el             = sticky_list[i];
			var el_height      = 0;
			var el_width       = 0;
			var el_parent      = el.parentNode;
			var el_placeholder = document.createElement("div");
			var el_ph_inserted = false;

			var own_z_index    = 9999 - i;
			var own_z_index_2  = 4999 - i;

			/* calculation variables */
			var el_state = 0; /* 0 no_sticky | 1 sticky | 2 no_more_sticky */
			var to_sticky_scroll_position = 0;
			var off_sticky_scroll_position = 0;

			/* Params */
			var params = {
				start_offset: 0, /* 0 | [number]  || in px */
				end: "parent", /* parent | never | [number]  || in px */
			}
			var raw_params = el.getAttribute("data-ezco-sticky");
			if( raw_params != "" ){
				raw_params = raw_params.split(";");
				if( typeof(raw_params[0]) != "undefined" ){
					// if a number, parse as int
					if( raw_params[0] === parseInt(raw_params[0])+"" ){
						params["start_offset"] = parseInt(raw_params[0]);
					// if not, query it (id or class) single and take the founds element height
					} else {
						var start_offset_el = document.querySelector(raw_params[0]);
						if( start_offset_el !== null ){
							// TODO: this is incorrect, as it is not the height, but
							//         the bottom border, that is of interest here
							params["start_offset"] = Math.ceil(start_offset_el.offsetHeight);
						}
					}
				}
				if( typeof(raw_params[1]) != "undefined" ){
					params["end"] = raw_params[1];
				}
			}
			el.setAttribute("data-ezco-sticky", "init");
			var switch_to_no_sticky = function(){
				if( el_state != 0 ){
					/* remove all sticky styles */
					// el
					el.style.width = "";
					el.style.position = "";
					el.style.top = "";
					el.style.zIndex = "";
					// el_parent
					if( el_ph_inserted ){
						// remove el_placeholder
						el_parent.removeChild(el_placeholder);
						el_ph_inserted = false;
					}
					el_state = 0;
					el.setAttribute("data-ezco-sticky", "static");
				}
			};
			var switch_to_sticky = function(){
				if( el_state != 1 ){
					/* position is now fixed */
					// el
					el.style.width = el_width+"px";
					el.style.position = "fixed";
					el.style.top = params["start_offset"] + "px";
					el.style.zIndex = own_z_index+"";

					// el_parent
					if( !el_ph_inserted ){
						// add el_placeholder
						el_parent.insertBefore(el_placeholder, el);
						el_ph_inserted = true;
					}
					el_state = 1;
					el.setAttribute("data-ezco-sticky", "sticky");
				}
			};
			var switch_to_no_more_sticky = function(){
				if( el_state != 2 ){
					/* position is now relative */
					// el
					el.style.width = "";
					el.style.position = "relative";
					el.style.top = (off_sticky_scroll_position - to_sticky_scroll_position)+"px";
					el.style.zIndex = own_z_index_2+"";
					// el_parent
					if( el_ph_inserted ){
						// remove el_placeholder
						el_parent.removeChild(el_placeholder);
						el_ph_inserted = false;
					}
					el_state = 2;
					el.setAttribute("data-ezco-sticky", "fixed");
				}
			};




			/* 100 ms (only on resize) */
			var calculate_scroll_positions = Fuchs.throttle(
				function(){


					switch_to_no_sticky();

					// starting boundary
					var el_boundings = el.getBoundingClientRect();
					to_sticky_scroll_position  = Math.ceil(el_boundings.top + window.pageYOffset);
					to_sticky_scroll_position -= params["start_offset"];

					// ending boundary
					switch( params["end"] ){
						case "parent":
						default:
							var el_parent_boundings = el_parent.getBoundingClientRect();
							off_sticky_scroll_position = Math.ceil(el_parent_boundings.top + window.pageYOffset + el_parent_boundings.height);
							off_sticky_scroll_position -= el_height;
							off_sticky_scroll_position -= params["start_offset"];
						break;
						case "never":
							/* assign -1, as it is always lower then to_sticky_scroll_position */
							off_sticky_scroll_position = -1;
						break;
						case parseInt(params["end"])+"":
							off_sticky_scroll_position = parseInt( params["end"] ) + to_sticky_scroll_position;
						break;
					}


					calculate_offsets();
					check_scroll_position();
				},
				100,
				true
			);
			/* 100 ms */
			var calculate_offsets = Fuchs.throttle(
				function(){
					/* memorize element height */
					el_height = el.offsetHeight;
					el_width = el.offsetWidth;
					var el_styles = window.getComputedStyle( el );

					/* resize placeholder to that height */
					el_placeholder.style.height       = el_height+"px";
					el_placeholder.style.marginTop    = el_styles.marginTop;
					el_placeholder.style.marginBottom = el_styles.marginBottom;


				},
				100,
				true
			);
			/* 50 ms */
			var check_scroll_position = Fuchs.throttle(
				function(){
					var current_scroll_position = window.pageYOffset;
					if( current_scroll_position <= to_sticky_scroll_position ){
						switch_to_no_sticky();
					} else{ /*  therefore: (current_scroll_position > to_sticky_scroll_position)  */

						/*   if off_sticky is smaller or same then to_sticky
						** or if current_pos is smaller then off_sticky
						**   => is sticky
						*/
						if( (off_sticky_scroll_position <= to_sticky_scroll_position)
							|| (current_scroll_position < off_sticky_scroll_position)
						){
							/* no end downwards */
							switch_to_sticky();
						} else { /*  therefore: (current_scroll_position >= off_sticky_scroll_position)  */
							switch_to_no_more_sticky();
						}
					}
				},
				30,
				true
			);
			document.addEventListener(
				"scroll",
				function(e){
					calculate_offsets();
					check_scroll_position();
				}
			);
			window.addEventListener(
				"resize",
				function(e){
					calculate_scroll_positions();
				}
			);
			/* start initiate sticky calculation */
			calculate_scroll_positions();
			setTimeout(
				calculate_scroll_positions,
				1000
			);



			// DEBUG
			window.addEventListener(
				"keypress",
				function(e){
					if( e.ctrlKey == true && e.charCode == 111 ){
						// scroll one down
						window.scrollBy(0, 1);
					}
					if( e.ctrlKey == true && e.charCode == 105 ){
						// scroll one up
						window.scrollBy(0, -1);
					}
				}
			);
		}())
	}
};















///** Die folgende Funktion ist Bibliotheks-Material.
// *  Allerdings ist sie noch nicht generalisiert genug,
// *    sodass ich das auf später verschoben habe.
// *    (Zeitdruck...)
//**/
//var tab_labels = document.querySelectorAll("label[for^=tab_]");
//	/* The following attribute-selector "[for^=tab_]" selects all elements
//	 *   with an attribute "for" which value begins with "tab_".
//	 */
//var i;
//for( i=0; i<tab_labels.length; i++ ){
//	/*  */
//	var cur_label = tab_labels[i];
//	cur_label.addEventListener(
//		"click",
//		function(e){
//			/* This timeout is a hack, to wait for the checkbox
//			 *   to actually change, before the function gets called.
//			 * It should be changed, when moving this function into the library.
//			 * Maybe the events target is useable for this.
//			 */
//			setTimeout(
//				update_label_status,
//				100
//			);
//		}
//	);
//}
//function update_label_status(){
//	for( i=0; i<tab_labels.length; i++ ){
//		var cur_label = tab_labels[i];
//		var cur_radio = document.querySelector( "#"+cur_label.getAttribute("for") );
//		if( cur_radio.checked ){
//			/* mark label as active */
//			cur_label.setAttribute("fuchs-tab_label", "active");
//		} else {
//			/* mark label as inactive */
//			cur_label.setAttribute("fuchs-tab_label", "inactive");
//		}
//	}
//}
//update_label_status();